export default __webpack_public_path__ + "static/media/linkedin.13a92f35.jpg";